import PropTypes from 'prop-types';

const propType = {
  id: PropTypes.string.isRequired,
  isDefault: PropTypes.bool.isRequired,
  bank_code: PropTypes.string,
  branch_code: PropTypes.string,
  country: PropTypes.string.isRequired,
  last4: PropTypes.string.isRequired,
  logo: PropTypes.string.isRequired,
};

export default { propType };
